@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.rowWrapper {
  margin-bottom: variables.$std-margin-md;
  max-width: 640px;
}

.schoolNameWrapper {
  width: 250px;
  margin-right: variables.$std-margin-md;
}

.inputWrapper {
  flex: 1;
}

.headerRow {
  background-color: variables.$gray-light-3;
  padding: variables.$std-padding-md;
  border-bottom: 1px solid variables.$gray-light-1;
  margin-top: variables.$std-margin-lg;
}
